<ion-toolbar style="padding: 10px 20px">
  <ion-title>
    <a href="https://copyfly.es/" target="_blank" rel="noopener noreferrer">
      <img
        class="adjust-bottom"
        src="../../assets/images/logo/logo-blanco.svg"
        style="width: 125px; height: auto; margin: 0px"
      />
    </a>
  </ion-title>
  <ion-title *ngIf="title">
    {{ title }}
  </ion-title>
  <ion-buttons slot="end">
    <ion-button
      [disabled]="disabled"
      class="price"
      color="dark"
      *ngIf="this.cartService.cart.items.length"
      (click)="openCartPreview()"
      routerDirection="forward"
    >
      <svg
        class="iconWhite shoppingCartIcon"
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 145 140"
        style="enable-background: new 0 0 145 140"
        xml:space="preserve"
      >
        <path
          d="M4.1,7.8c0.5,0.3,1.1,0.5,1.6,0.8C7,9,8.2,9.4,9.5,9.9c3.5,1.2,7,2.5,10.6,3.7c4.6,1.5,9.3,3,13.9,4.4l1.8,0.6
          c0.9,0.2,1.6,0.7,2.2,1.3s1,1.5,1.1,2.4c0.4,2,0.8,4.1,1.2,6.1c0.4,1.8,0.7,3.6,1.1,5.5c0.5,2.9,1.1,5.7,1.6,8.6
          c1.4,7.6,2.9,15.4,4.1,23.2c0.7,4.3,1.1,8.8,1.4,13.1c0.4,3.9,0.7,8,1.3,12l0.1,1.1c0.7,5.1,1.4,9.8,1.3,14.8
          c-0.1,9.4,3.6,13.3,13.3,14c7.4,0.6,14.8,0.8,22.3,0.8c8.7,0,17.3-0.3,25.8-0.5c6.9-0.2,14-0.4,21-0.5h0.2c0.9,0,1.8-0.1,2.7-0.3
          l0.4-0.1c1.3-0.3,2.6-0.8,3.8-1.5c0.8-0.5,1.5-1.2,2-2.1c0.5-0.9,0.7-1.8,0.7-2.8c0-0.9-0.3-1.9-0.9-2.7c-0.5-0.8-1.2-1.4-2.1-1.9
          c-1.8-0.9-3.8-1.4-5.8-1.4c-5.3,0.1-10.7,0.2-15.9,0.4c-6.8,0.2-13.9,0.4-20.8,0.5c-7.8,0.1-15.7-0.1-23.3-0.3c-3-0.1-6-0.1-9-0.2
          c-0.6,0-1.2-0.1-1.8-0.2c-0.3,0-0.5-0.1-0.8-0.1l-2.4-12.5l2.1-0.2c1.9-0.2,3.6-0.3,5.3-0.5l10-0.9c12.6-1.1,25.6-2.2,38.4-3.3
          c4.9-0.4,8.2-2.8,10.1-7.3l0.6-1.4c1.1-2.9,2.4-5.6,3.8-8.3c3.9-6.9,6.7-14.4,9.5-21.6l0.7-1.9c1.5-4,3.3-9.4,3.2-15.3
          c-0.1-4.8-2.2-7.2-7.1-7.5c-0.7-0.1-1.3-0.1-2.1-0.1c-5.5,0-10.9,0-16.4,0.1c-13.7,0-28,0.1-41.9,0.3c-5.5,0.1-11.1,0.4-16.4,0.7
          c-2.6,0.1-5.2,0.3-7.8,0.4c-0.6,0-1.1,0-1.8,0l-0.4,0c-0.2-0.7-0.3-1.5-0.5-2.2c-0.5-2-0.9-3.9-1.4-5.9c-1.3-5.1-4.2-8.2-8.9-9.6
          c-7.1-2.1-14.2-4.3-21.1-6.5c-3.3-1.1-6.7-2.1-10-3.1C7.7,0.9,6.9,0.7,6.2,0.7c-1.6-0.1-3.8,0-4.4,2.5C1.3,5.2,2.1,6.7,4.1,7.8z
           M51.9,35.1c0.7,0,1.4-0.1,2.2-0.1c2.1-0.1,4.1-0.2,6.1-0.2c4.4,0,8.9,0,13.2,0c3.7,0,7.4,0,11,0c6.2,0,12.4,0,18.5,0
          c8.3,0,16.6,0,24.9,0c1.8,0,3.6,0.1,5.5,0.3c0.7,0,1.4,0.1,2.2,0.1c-0.3,1-0.5,1.9-0.8,2.8c-0.6,2.4-1.3,4.7-2.2,6.9
          c-2.4,5.6-5.1,11.2-7.6,16.7c-1,2-1.9,4.1-2.9,6.1c-1.2,2.7-2.5,5.3-3.8,8.2l-1.9,4l-56.9,5.4C58.5,70.3,56.1,54.3,51.9,35.1z"
        />
        <path
          d="M123.3,138.7c2.5,0,4.9-1,6.7-2.8c0.8-0.7,1.4-1.6,1.8-2.6c0.4-1,0.6-2,0.6-3.1c0-4.5-4.3-8.6-9-8.7h-0.1
          c-2.3,0-4.5,0.9-6.2,2.5c-1.7,1.6-2.6,3.8-2.7,6.1c0,1.1,0.2,2.2,0.6,3.2c0.4,1,1,1.9,1.8,2.7c0.9,0.9,1.9,1.5,3,2
          C120.8,138.5,122,138.7,123.3,138.7L123.3,138.7z"
        />
        <path
          d="M69.5,139.4L69.5,139.4c2.3,0,4.4-0.9,6-2.4c1.6-1.5,2.5-3.6,2.6-5.8c0.1-4.8-4.2-9.4-8.7-9.5
          c-2.2,0-4.3,0.9-5.8,2.5c-1.8,1.7-2.8,4-2.9,6.5c0,1.1,0.3,2.2,0.7,3.3c0.4,1,1.1,2,1.9,2.7C64.9,138.3,67.1,139.3,69.5,139.4z"
        />
      </svg>
      <ion-badge color="danger" slot="end" style="position: absolute; right: -5px; top: 8px">
        {{ this.cartService.cart.items.length }}</ion-badge
      >
    </ion-button>
    <ion-button color="primary" (click)="onMenu()" [disabled]="disabled">
      <svg
        class="burger-menu-icon"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        id="Capa_1"
        x="0px"
        y="0px"
        viewBox="0 0 50 50"
        xml:space="preserve"
      >
        <g>
          <defs>
            <rect id="SVGID_1_" x="0.2" y="7.2" width="49.7" height="35.5"></rect>
          </defs>
          <clipPath id="SVGID_2_">
            <use xlink:href="#SVGID_1_" style="overflow: visible"></use>
          </clipPath>
          <g>
            <path
              d="M0.2,40.2c-0.1,0.8,0.5,1.7,1.4,2c0.5,0.1,1,0.2,1.5,0.3c0.4,0,0.8,0,1.2,0.1c1,0,2,0.1,3,0.1c0.4,0,0.8,0,1.2,0    c1.9-0.1,3.9-0.2,5.8-0.3c2.3-0.1,4.6-0.3,7-0.4c6-0.2,12.1-1,18-1.8l0.8-0.1c1.4-0.2,2.8-0.4,4.2-0.7c0.1,0,0.1,0,0.2,0    c0.6-0.1,1.4-0.2,1.6-1.5c0-0.1,0-0.1,0-0.2c0-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.3-0.1-0.4-0.1c-0.3-0.1-0.5-0.2-0.8-0.2L43.7,37    c-2-0.1-4.1-0.2-6.2-0.3c-5.9-0.2-11.8,0-17.6,0.5c-3.8,0.3-7.6,0.6-11.4,0.8c-1.9,0.1-3.8,0.2-5.7,0.4c-0.4,0-0.8,0.1-1.2,0.2    c-0.4,0.1-0.7,0.3-1,0.6C0.4,39.5,0.3,39.8,0.2,40.2z"
            ></path>
            <path
              d="M1.2,25.7c0,0.3,0.1,0.6,0.2,0.9c0.2,0.3,0.4,0.5,0.6,0.6c0.5,0.2,1,0.4,1.5,0.4c0.7,0,1.4,0.1,2.1,0.1c0.4,0,0.7,0,1.1,0    c2.1-0.1,4.2-0.3,6.3-0.4c3.9-0.3,7.9-0.5,11.8-0.7c5.4-0.2,10.8-0.8,16-1.5c1.4-0.2,2.7-0.3,4.1-0.5c0.1,0,0.2,0,0.3,0    c0.8-0.1,1.8-0.2,2.8-1.3c0,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1-0.1-0.1c0,0-0.1-0.1-0.1-0.1c-1.9-0.8-3.5-0.9-5.1-0.9    l-1.4,0c-4.5-0.1-9.1-0.3-13.7-0.1c-7.7,0.3-15.2,1-23.5,1.9C3.5,23.8,2.8,24,2,24.3c-0.3,0.1-0.5,0.3-0.6,0.6    C1.3,25.1,1.2,25.4,1.2,25.7z"
            ></path>
            <path
              d="M2.8,11.2c0.5,0.3,1.1,0.4,1.7,0.5c0.3,0,0.7,0,1,0.1C7,11.9,8.6,12,10.2,12c0.1,0,0.2,0,0.4,0c2.9,0,5.9-0.1,8.8-0.2    c3.8-0.1,7.8-0.2,11.7-0.2c5.6,0,11.2-0.7,16.6-1.3l0.2,0c0.3-0.1,0.7-0.2,1-0.4c0.2-0.1,0.4-0.2,0.7-0.3c0,0,0.1-0.1,0.1-0.1    c0,0,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0,0-0.1-0.1-0.1-0.1c-0.3-0.1-0.5-0.3-0.7-0.4c-0.3-0.2-0.7-0.4-1.1-0.5l-1.1-0.1    c-2.1-0.2-4.2-0.5-6.3-0.6c-11.4-0.5-23,0-34.2,0.4L4.1,8C3.8,8,3.5,8.1,3.2,8.1C2.8,8.2,2.5,8.4,2.3,8.6C2,8.9,1.9,9.2,1.9,9.5    c-0.1,0.3,0,0.7,0.2,1C2.2,10.8,2.5,11.1,2.8,11.2z"
            ></path>
          </g>
        </g>
      </svg>
    </ion-button>
  </ion-buttons>

  <ion-row class="ion-align-items-center ion-justify-content-center link-space"> </ion-row>
  <ion-row class="ion-align-items-center link-space"> </ion-row>
</ion-toolbar>
